import React from 'react';
import IconDetail from './IconDetail';
import { RichText } from 'prismic-reactjs';
import { linkResolver } from '../../prismic-configurations';
import '../../css/featured-card.css';

const FeaturedCard = ({
  onClick,
  tags,
  data,
  showLiveOrHighlight,
  highlightTagInfo
}) => {
  return (
    <div className="featured-card featured card" onClick={onClick}>
      <div id="featured-container">
        <div className="featured__img">
          <div className="img-container">
            <img src={data.image.url} alt={data.title} />
          </div>
        </div>
        <div className="featured__details">
          <div>
            <div className="featured-title">
              <h2>{data.title[0].text}</h2>
            </div>
            <RichText
              Component="div"
              className="featured-description"
              render={data.description}
              linkResolver={linkResolver}
            />

            <IconDetail type="date" value={data.date} />
            <IconDetail type="time" value={data.date} />
            <IconDetail type="cost" value={data.cost} />
          </div>
        </div>
      </div>
      <div className="featured__tags">
        <span className="topic-tag">{tags?.[0]}</span>
        <span className="duration-tag">{data.duration}</span>
        <span className="venue-tag">{data.location}</span>
        {!showLiveOrHighlight ? (
          <span
            className={`registration-tag ${
              data.status === 'Registration Open' ? 'open' : 'closed'
            }`}
          >
            {data.status}
          </span>
        ) : showLiveOrHighlight === 'live' ? (
          <span className="live-tag">Live</span>
        ) : showLiveOrHighlight === 'highlight' ? (
          <span className="highlight-tag">{highlightTagInfo}</span>
        ) : null}
      </div>
    </div>
  );
};

export default FeaturedCard;
